<div class="card">
    <div class="card-body">
      <div class="mb-4 d-md-flex align-items-center justify-content-between">
        <div>
          <h4>Personal Information</h4>
          <p>Basic info, like your name and address on this account.</p>
        </div>
      </div>
      <form [formGroup]="addUserForm" (ngSubmit)="addUser()">
        <div class="row">
          <!-- First Name -->
          <div class="col form-group mb-3">
            <label for="firstName" class="form-label">First Name</label>
            <input type="text" formControlName="firstName" id="firstName" class="form-control"
              (keypress)="onlyAlphabet($event)"
              (input)="filterNameInput($event)"
              (paste)="preventPaste($event)"
              (drop)="preventDrop($event)" />
            <div *ngIf="addUserForm.get('firstName')?.invalid && (addUserForm.get('firstName')?.dirty || addUserForm.get('firstName')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('firstName')?.errors?.required">First Name is required.</div>
              <div *ngIf="addUserForm.get('firstName')?.errors?.pattern">First Name must contain only letters.</div>
            </div>
          </div>
  
          <!-- Last Name -->
          <div class="col form-group mb-3">
            <label for="lastName" class="form-label">Last Name</label>
            <input type="text" formControlName="lastName" id="lastName" class="form-control"
              (keypress)="onlyAlphabet($event)"
              (input)="filterNameInput($event)"
              (paste)="preventPaste($event)"
              (drop)="preventDrop($event)" />
            <div *ngIf="addUserForm.get('lastName')?.invalid && (addUserForm.get('lastName')?.dirty || addUserForm.get('lastName')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('lastName')?.errors?.required">Last Name is required.</div>
              <div *ngIf="addUserForm.get('lastName')?.errors?.pattern">Last Name must contain only letters.</div>
            </div>
          </div>
        </div>
  
        <div class="row">
          <!-- Email -->
          <div class="col form-group mb-3">
            <label for="email" class="form-label">Email</label>
            <input type="email" formControlName="email" id="email" class="form-control" />
            <div *ngIf="addUserForm.get('email')?.invalid && (addUserForm.get('email')?.dirty || addUserForm.get('email')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('email')?.errors?.required">Email is required.</div>
              <div *ngIf="addUserForm.get('email')?.errors?.pattern">Invalid email address format.</div>
            </div>
          </div>
  
          <!-- Phone Number -->
          <div class="col form-group mb-3">
            <label for="phone" class="form-label">Phone Number</label>
            <input type="text" formControlName="phone" id="phone" class="form-control"
              (input)="filterPhoneNumber($event)"
              (paste)="preventPaste($event)"
              (drop)="preventDrop($event)" />
            <div *ngIf="addUserForm.get('phone')?.invalid && (addUserForm.get('phone')?.dirty || addUserForm.get('phone')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('phone')?.errors?.required">Phone Number is required.</div>
              <div *ngIf="addUserForm.get('phone')?.errors?.pattern">Phone Number must be numeric.</div>
              <div *ngIf="addUserForm.get('phone')?.errors?.minlength">Phone Number must be at least 10 digits long.</div>
              <div *ngIf="addUserForm.get('phone')?.errors?.maxlength">Phone Number must be no longer than 15 digits.</div>
            </div>
          </div>
        </div>
  
        <div class="row">
          <!-- Address -->
          <div class="col form-group mb-3">
            <label for="address" class="form-label">Address</label>
            <input type="text" formControlName="address" id="address" class="form-control" />
            <div *ngIf="addUserForm.get('address')?.invalid && (addUserForm.get('address')?.dirty || addUserForm.get('address')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('address')?.errors?.required">Address is required.</div>
            </div>
          </div>
  
          <!-- Zip Code -->
          <div class="col form-group mb-3">
            <label for="zip" class="form-label">Zip Code</label>
            <input type="text" formControlName="zip" id="zip" class="form-control"
              (input)="filterZipCode($event)"
              (paste)="preventPaste($event)"
              (drop)="preventDrop($event)" />
            <div *ngIf="addUserForm.get('zip')?.invalid && (addUserForm.get('zip')?.dirty || addUserForm.get('zip')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('zip')?.errors?.required">Zip Code is required.</div>
              <div *ngIf="addUserForm.get('zip')?.errors?.pattern">Invalid Zip Code format.</div>
            </div>
          </div>
        </div>
  
        <div class="row">
          <!-- State -->
          <div class="col form-group mb-3">
            <label for="state" class="form-label">State</label>
            <input type="text" formControlName="state" id="state" class="form-control" />
            <div *ngIf="addUserForm.get('state')?.invalid && (addUserForm.get('state')?.dirty || addUserForm.get('state')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('state')?.errors?.required">State is required.</div>
            </div>
          </div>
  
          <!-- Position -->
          <div class="col form-group mb-3">
            <label for="position" class="form-label">Position</label>
            <input type="text" formControlName="position" id="position" class="form-control" />
            <div *ngIf="addUserForm.get('position')?.invalid && (addUserForm.get('position')?.dirty || addUserForm.get('position')?.touched)" class="text-danger">
              <div *ngIf="addUserForm.get('position')?.errors?.required">Position is required.</div>
            </div>
          </div>
        </div>
  
        <!-- Profile Picture -->
        <div class="form-group mb-3">
          <label for="profilePic" class="form-label">Profile</label>
          <input type="file" formControlName="profilePic" id="profilePic" class="form-control"
            (change)="fileChangeEvent($event)" accept=".jpg, .png, .jpeg" />
          <div *ngIf="imageError" class="text-danger">{{ imageError }}</div>
        </div>
  
        <div class="text-end">
          <button type="submit" class="btn btn-outline-dark" [disabled]="addUserForm.invalid">Submit</button>
          <button class="btn btn-outline-danger ms-2" (click)="resetForm()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
  